import { Component } from '@angular/core';
import { HomePage } from '../home/home';
import { ListMenus } from '../menus/menus';
import { PreferencesPage} from '../preferences/preferences';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  tab1Root: any = HomePage;
  tab2Root: any = ListMenus;
  tab3Root: any = PreferencesPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts